import React, { useContext } from 'react';

import { ArrowAngleRight } from '@zooplus/icons';
import { NumberBadge } from '@zooplus/ui-components';

import LocResourcesContext from '../../../common/contexts/LocResourcesContext';

type FilterCategoryButtonProps = {
  view: string;
  selectedCategoryTypes?: string[];
  setView: (view: string) => void;
  buttonText: string;
  numberBadgeAriaLabel: string;
};

export const FilterCategoryButton = ({
  view,
  selectedCategoryTypes,
  setView,
  buttonText,
  numberBadgeAriaLabel,
}: FilterCategoryButtonProps) => {
  const { onFormatLocale } = useContext(LocResourcesContext);

  return (
    <button className="filterCategoryButton" onClick={() => setView(view)}>
      {onFormatLocale?.(buttonText)}
      <div className="arrowContainer">
        {selectedCategoryTypes?.length !== 0 && selectedCategoryTypes?.length && (
          <NumberBadge
            amount={selectedCategoryTypes.length}
            variant="primary"
            aria-label={onFormatLocale?.(numberBadgeAriaLabel, {
              number: selectedCategoryTypes.length,
            })}
          />
        )}
        <ArrowAngleRight aria-hidden />
      </div>
    </button>
  );
};
